import React, { useState } from 'react';
import Documents from './Documents';
import Induction from './Induction';
import Staff from './Staff';
import NonConformances from './NonConformances';
import Audits from './Audits';
import Objectives from './Objectives';
import ManagementReview from './ManagementReview';
import Suppliers from './Suppliers';
import Equipment from './Equipment';
import CustomerFeedback from './CustomerFeedback';
import './Dashboard.css';

const NAV_ITEMS = [
  { id: 'home', label: 'HOME', icon: '⌂', roles: ['admin', 'staff', 'auditor'] },
  { id: 'documents', label: 'DOCUMENTS', icon: '📋', roles: ['admin', 'staff', 'auditor'] },
  { id: 'training', label: 'TRAINING', icon: '🎓', roles: ['admin', 'staff', 'auditor'] },
  { id: 'equipment', label: 'EQUIPMENT', icon: '⚙️', roles: ['admin', 'auditor'] },
  { id: 'audits', label: 'AUDITS', icon: '🔍', roles: ['admin', 'auditor'] },
  { id: 'non-conformances', label: 'NON-CONFORMANCES', icon: '⚠️', roles: ['admin', 'auditor'] },
  { id: 'customer-feedback', label: 'CUSTOMER FEEDBACK', icon: '💬', roles: ['admin', 'auditor'] },
  { id: 'objectives', label: 'OBJECTIVES', icon: '🎯', roles: ['admin', 'auditor'] },
  { id: 'management-review', label: 'MANAGEMENT REVIEW', icon: '📊', roles: ['admin', 'auditor'] },
  { id: 'suppliers', label: 'SUPPLIERS', icon: '🏢', roles: ['admin', 'auditor'] },
  { id: 'staff', label: 'STAFF', icon: '👥', roles: ['admin', 'auditor'] },
];

export default function Dashboard({ user, onLogout }) {
  const [activePage, setActivePage] = useState('home');
  const [menuOpen, setMenuOpen] = useState(false);

  const navItems = NAV_ITEMS.filter(item => item.roles.includes(user.role));

  const renderPage = () => {
    switch (activePage) {
      case 'documents': return <Documents user={user} />;
      case 'inductions': return <Induction user={user} />;
      case 'staff': return <Staff user={user} />;
      case 'non-conformances': return <NonConformances user={user} />;
      case 'customer-feedback': return <CustomerFeedback user={user} />;
      case 'audits': return <Audits user={user} />;
      case 'objectives': return <Objectives user={user} />;
      case 'management-review': return <ManagementReview user={user} />;
      case 'suppliers': return <Suppliers user={user} />;
      case 'equipment': return <Equipment user={user} />;
      default: return <HomePage user={user} onNavigate={setActivePage} navItems={navItems} />;
    }
  };

  const activeItem = navItems.find(i => i.id === activePage);

  return (
    <div className="dashboard">
      <header className="dash-header">
        <div className="dash-header-left">
          <img src="/bramley-logo.svg" alt="Bramley Engineering" className="dash-logo-img" />
          <div className="dash-header-divider" />
          <img src="/vera-logo-header.svg" alt="Vera QMS" className="dash-vera-logo" />
        </div>
        <div className="dash-header-right">
          <div className="dash-user">
            <div className="dash-user-avatar">{user.first_name[0]}{user.last_name[0]}</div>
            <div className="dash-user-info">
              <span className="dash-user-name">{user.first_name} {user.last_name}</span>
              <span className="dash-user-role">{user.role.toUpperCase()}</span>
            </div>
          </div>
          <button className="dash-logout" onClick={onLogout}>SIGN OUT</button>
          <button className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>☰</button>
        </div>
      </header>

      <div className="dash-body">
        <nav className={`dash-nav ${menuOpen ? 'open' : ''}`}>
          {navItems.map(item => (
            <button
              key={item.id}
              className={`nav-item ${activePage === item.id ? 'active' : ''}`}
              onClick={() => { setActivePage(item.id); setMenuOpen(false); }}
            >
              <span className="nav-icon">{item.icon}</span>
              <span className="nav-label">{item.label}</span>
            </button>
          ))}
        </nav>

        <main className="dash-main">
          {activePage !== 'home' && (
            <div className="page-header">
              <button className="back-btn" onClick={() => setActivePage('home')}>← HOME</button>
              <h2 className="page-title">{activeItem?.icon} {activeItem?.label}</h2>
            </div>
          )}
          <div className="page-content">
            {renderPage()}
          </div>
        </main>
      </div>
    </div>
  );
}

function HomePage({ user, onNavigate, navItems }) {
  return (
    <div className="home-page">
      <div className="dash-welcome">
        <h1>GOOD {getTimeOfDay()}, <span className="yellow">{user.first_name.toUpperCase()}</span></h1>
        <p>Welcome to Vera — Bramley Engineering Quality Management System</p>
      </div>
      <div className="dash-cards">
        {navItems.filter(i => i.id !== 'home').map(item => (
          <div key={item.id} className="dash-card" onClick={() => onNavigate(item.id)}>
            <div className="card-icon">{item.icon}</div>
            <h3>{item.label}</h3>
          </div>
        ))}
      </div>
    </div>
  );
}

function getTimeOfDay() {
  const h = new Date().getHours();
  if (h < 12) return 'MORNING';
  if (h < 17) return 'AFTERNOON';
  return 'EVENING';
}
